import styles from "./toolbox-all-labels.module.css";
import { usePosterProject } from "PosterEditor/model/poster-project-provider";
import { useEditorUI } from "PosterEditor/use-editor-ui";
import { DeleteButton } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-button";
import { Element } from "PosterEditor/model/poster-types";
import { MapLabel, StaticLabel } from "PosterEditor/model/poster-project";
import { Reorder } from "motion/react";
import { useState } from "react";
import { UIIcon } from "PosterEditor/common-components/ui-icon-drawing/ui-icon";
import { UIIconName } from "PosterEditor/common-components/ui-icon-drawing/ui-icon-type";

interface ToolboxAllLabelsProps {}

export const ToolboxAllLabels = (props: ToolboxAllLabelsProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {/* <MapLabelList /> */}
        <StaticLabelList />
      </div>
    </div>
  );
};

const StaticLabelList = () => {
  const { project, removeStaticLabel } = usePosterProject();
  const { setEditingElement } = useEditorUI();
  const staticLabels = project.staticLabels;

  const elementFromStaticLabel = (label: StaticLabel): Element => {
    return {
      type: "staticLabel",
      id: label.id,
      staticLabel: label,
    };
  };

  return (
    <div className={styles.labelList}>
      <div className={styles.listContent}>
        {staticLabels.map((label) => (
          <div key={label.id} className={styles.item}>
            <button
              className={styles.itemButton}
              onClick={() => {
                console.log("Label clicked:", label.id, label.description);
                setEditingElement(elementFromStaticLabel(label));
              }}
            >
              <div className={styles.itemContentLeading}>
                <UIIcon iconName={"STATIC-LABEL"} size={22} variant="REGULAR" />
                <div className={styles.textContent}>
                  <h3>{label.description}</h3>
                  <span className={styles.labelPlaceText}>{label.text}</span>
                </div>
              </div>
            </button>
            <div className={styles.trailingControls}>
              <DeleteButton onClick={() => removeStaticLabel(label)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
